import { useRecurrenceType } from '../../providers/StateProvider'
import { useUiFramework } from '../../providers/UiFrameworkProvider'
import { RecurrenceSettingsAnnually } from './layouts/RecurrenceSettingsAnnually'
import { RecurrenceSettingsDaily } from './layouts/RecurrenceSettingsDaily'
import { RecurrenceSettingsMonthly } from './layouts/RecurrenceSettingsMonthly'
import { RecurrenceSettingsNoRepeat } from './layouts/RecurrenceSettingsNoRepeat'
import { RecurrenceSettingsWeekly } from './layouts/RecurrenceSettingsWeekly'

export type RecurrenceSettingsLayoutProps = {
  inEditMode: boolean
}

export function RecurrenceSettingsLayout(props: RecurrenceSettingsLayoutProps) {
  const { inEditMode } = props
  const recurrenceType = useRecurrenceType()
  const uiFramework = useUiFramework()

  switch (recurrenceType) {
    case 'NO_REPEAT':
      return <RecurrenceSettingsNoRepeat />
    case 'DAILY':
      return <RecurrenceSettingsDaily uiFramework={uiFramework} inEditMode={inEditMode} />
    case 'WEEKLY':
      return <RecurrenceSettingsWeekly uiFramework={uiFramework} inEditMode={inEditMode} />
    case 'MONTHLY':
      return <RecurrenceSettingsMonthly uiFramework={uiFramework} inEditMode={inEditMode} />
    case 'ANNUALLY':
      return <RecurrenceSettingsAnnually uiFramework={uiFramework} inEditMode={inEditMode} />
  }
}
